/**
 * @license Angular v20.0.2
 * (c) 2010-2025 Google LLC. https://angular.io/
 * License: MIT
 */

import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

/**
 * This class wraps the platform Navigation API which allows server-specific and test
 * implementations.
 */
let PlatformNavigation = /*#__PURE__*/(() => {
  class PlatformNavigation {
    static ɵfac = function PlatformNavigation_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PlatformNavigation)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PlatformNavigation,
      factory: () => (() => window.navigation)(),
      providedIn: 'platform'
    });
  }
  return PlatformNavigation;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { PlatformNavigation };
